import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  FeaturedArticlesStore,
} from '../../mobx-store/stores/featuredArticlesStore';

interface IProps {
  featuredArticlesStore?: FeaturedArticlesStore;
  countryStore?: CountryStore;
  history?: any;
}

interface State {
  currentElement: number;
}

@inject('featuredArticlesStore')
@inject('countryStore')
@observer
class HistoryFeaturedArticles extends Component<IProps & RouteComponentProps, State> {
  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.title = translate('featuredArticlesPageTitle', {
    });
    this.state = {
      currentElement: 0,
    };
  }

  disableStatus = (index: number) => !this.props.featuredArticlesStore!.featuredArticlesList[index].isActive;

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.featuredArticlesStore!.updateFeaturedArticleStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/featured-articles/${this.props.featuredArticlesStore!.featuredArticlesList[index].featuredArticleId}/edit`);
  };

  getFeaturedArticlesTableHeaders = () => [
    {
      title: translate('featuredArticlesTableTitleColumn', {
      }),
    },
    {
      title: translate('featuredArticlesTableStatusColumn', {
      }),
    },
    {
      title: translate('featuredArticlesTableEditColumn', {
      }),
    },
  ];

  getFeaturedArticlesTableData = () => {
    console.log(this.props.featuredArticlesStore!.featuredArticlesList);
    return this.props.featuredArticlesStore!.featuredArticlesList;
  };

  getFeaturedArticlesTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Text',
      key: 'isActive',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  getTableData = () => {
    this.tableHeader = this.getFeaturedArticlesTableHeaders();
    this.tableData = this.getFeaturedArticlesTableData();
    this.tableCellTypes = this.getFeaturedArticlesTableCellTypes();
  };

  render() {
    this.getTableData();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('noFeatuerdArticlesMessage', {
          })}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          loadingStatus={[
            this.props.featuredArticlesStore!.getFeaturedArticlesRequestStatus,
            this.props.countryStore!.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, featuredArticlesStore,
    } = this.props;
    await countryStore!.getUserManagedCountries();

    featuredArticlesStore!.getHistoryFeaturedArticles(countryStore!.managedCountries);
  }
}

export default withRouter(HistoryFeaturedArticles);
